import { ReactNode } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { SessionExcludeModel } from './sessionExcludeModel';
import Loading from 'components/loading';

export const SessionExcludeModal = (props: { model: SessionExcludeModel }) => {
	const { isLoading, sessions, onAcceptClicked, onCancelClicked } = props.model;

	return (
		<Modal show={sessions.length > 0} size="lg" centered>
			<Modal.Header>
				<Modal.Title>Exclude/Include Session</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MainMessage sessions={sessions} />
			</Modal.Body>
			<Modal.Footer>
				<Loading loading={isLoading} />
				<Button
					id="btnExcludeSessions"
					onClick={onAcceptClicked}
					disabled={isLoading}
				>
					{sessions[0]?.isExcluded === true ? 'Include' : 'Exclude'}
				</Button>
				<Button
					id="btnQuit"
					variant="outline-primary"
					onClick={onCancelClicked}
					disabled={isLoading}
				>
					Cancel
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

const MainMessage = (props: {
	sessions: {
		SessionID: number;
		SessionName: string;
		isExcluded: boolean;
	}[];
}) => {
	return (
		<>
			<p>
				Are you sure you want to{' '}
				{props.sessions[0]?.isExcluded === true ? 'include' : 'exclude'} weights
				in this session from reports and ADG calculations?
			</p>
			<div style={{ textAlign: 'center', fontWeight: 'bold' }}>
				{props.sessions.map((row) => (
					<p key={row.SessionID}>
						{row.SessionName} [{row.SessionID}]
					</p>
				))}
			</div>
		</>
	);
};
